export class DownloadManager {
  public async initialize() {}
  public async start() {
    return [];
  }
  public async dispose() {}

  public async downloadCollection() {}

  public async cancelOrDeleteDownloads() {}

  public async onAddSongToPlaylist() {}

  public async onRemoveSongFromPlaylist() {}

  public async updateOfflineCollection() {}

  public async reset() {}

  public async resumePendingDownloads() {}

  public async handleOfflineAccessInvalidated() {}

  public async getOfflineAlbums() {}

  public async getOfflineSongsByAlbumId() {}

  public async getOfflinePlaylists() {}

  public async getOfflineSongsByPlaylistIds() {}

  public async getOfflineLibrary() {}

  public async getOfflineSongsById() {}

  public async getOfflineTodaysTopHits() {}

  public addEventListener() {}
}
